"use strict";
/****************************************************
 * Audit Information Platform Component
 * 多选参照项基类 (该组件由于目前没有应用场景，所以没有完全实现)
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- iUAP ------
var tinper_bee_1 = require("tinper-bee");
//----- AIP ------
var RefItem_1 = require("./RefItem");
var CheckboxGroup = tinper_bee_1.Checkbox.CheckboxGroup;
/**
 * 多选框参照组件
 *
 * @class CheckRef
 *
 * @extends { RefItem }
 *
 * @description 复选框组件
 */
var CheckRef = /** @class */ (function (_super) {
    __extends(CheckRef, _super);
    function CheckRef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            options: [],
            value: '',
        };
        _this.hasRefItems = function () {
            return true; // 暂时没有实现，该组件目前不可用
        };
        _this.validConditions = function () {
            return false; // 暂时没有实现，该组件目前不可用
        };
        /**
         * 转换数据为{label: value}的数组
         * @function
         */
        _this._prepareData = function (arr) {
            var datas = [];
            arr.forEach(function (element) {
                var item = {};
                try {
                    var label = element[_this.props.displayfield];
                    var value = element[_this.props.valuefield];
                    item['label'] = label;
                    item['value'] = value;
                    datas.push(item);
                }
                catch (e) {
                }
            });
            return datas;
        };
        /**
         * 远程请求数据
         * @function
         *
         * @returns {void}
         */
        _this._loadData = function () {
            if (_this.props.options)
                return; // 如果是直接显示的，就不load数据了
            if (_this.validConditions()) {
            }
        };
        /**
         * 重置值 **override**
         * @function
         */
        _this.clear = function () {
            _this.setState({ defaultValue: [], value: '' }, function () {
            });
        };
        /**
         * 获取值， **override**
         * @function
         */
        _this.getValue = function () {
            return _this.state.value;
        };
        /**
         * 值发生变化调用
         * @function
         *
         * @param {string[]} checkedValues
         */
        _this._onChange = function (checkedValues) {
        };
        return _this;
    }
    CheckRef.prototype.componentDidMount = function () {
        if (!this.props.options || this.props.options.length === 0) { // 如果没有options，就从网络拉取数据
            if (this.hasRefItems()) { // 如果有依赖，先不处理
                // igonre
            }
            else {
                this._loadData();
            }
        }
        else { // 有options就直接显示
            this.setState({ options: this._prepareData(this.props.options || []) }, function () {
            });
        }
    };
    CheckRef.prototype.render = function () {
        return (React.createElement(CheckboxGroup, { options: this.state.options, defaultValue: [], onChange: this._onChange }));
    };
    return CheckRef;
}(RefItem_1.default));
exports.default = CheckRef;
